import { featuresForCurrentBrand } from '@b2ag/app-brands/src/features'
import { appBrands, currentAppBrand } from '@b2ag/app-brands'
import { getConfig } from '@b2ag/micro-front-tools'

export function initEqualWeb() {
  if (featuresForCurrentBrand.equalWeb) {
    if (window.location.hostname.includes('localhost')) return

    import('@b2ag/equalweb').then(({ injectWidgetEqualWeb }) =>
      injectWidgetEqualWeb(
        currentAppBrand === appBrands.Countrymalt ? 'CMG' : undefined,
        getConfig('ENVIRONMENT_NAME'),
      ),
    )
  }
}
